import { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { SettingsPageHeader } from 'components/atoms/settings-page-header';
import { SettingsPageTitleWrapper } from 'components/atoms/settings-page-title-wrapper';
import { FilterBar } from 'components/molecules/filter-bar';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { SettingsPage } from 'routes/settings/setting-page-layout-style';

interface Props {
  documentTitle: string;
  icon: ReactNode;
}

const Content = styled(Page.Content)`
  padding: var(--layout-03);
  padding-left: var(--layout-02);
  ${FilterBar} {
    padding: 0;
    margin-bottom: var(--layout-02);
    box-shadow: none;
  }
`;

export const Helium: FC<React.PropsWithChildren<Props>> = ({
  icon,
  documentTitle,
  children,
}) => {
  return (
    <SettingsPage>
      <SettingsPageHeader
        titleComponent={
          <SettingsPageTitleWrapper>
            <HeaderWithIconTitle icon={icon} title={documentTitle} />
          </SettingsPageTitleWrapper>
        }
      />
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>
      <Content>{children}</Content>
    </SettingsPage>
  );
};
